<div class="wizard-inner-container">
    <div class="wizard-registration-title">
        {{ "onboarding.titles.add_technicians" | translate }}
    </div>
    <div *ngIf="workshopSelected && technicians && technicians.length > 0">
        <div class="existing-technicians-header text-light">{{ 'onboarding.existing_technicians' | translate}}</div>
        <ul>
            <li *ngFor="let tech of technicians;let i = index;trackBy: indexTracker">
              <span class="text-light">
                {{tech.Firstname}} {{tech.Surname}}
              </span>
            </li>
        </ul>
    </div>
    <div class="wizard-form">
        <div *ngIf="!workshopSelected" class="skip-step-info">
            {{'onboarding.only_needed_for_workshop' | translate }}
        </div>
        <div *ngIf="workshopSelected">
            <div class="row margin-top-32 margin-bottom-32 help-row">
                <div class="col-md-12">
                    <div class="input-group">
                        <input class="sign-up-input" type="number" [ngModel]="techniciansNumber" (ngModelChange)="change($event)" placeholder="{{ 'onboarding.number_technicians' | translate}}"/>
<!--                        <label>{{ 'onboarding.number_technicians' | translate}}</label>-->
                    </div>
                </div>
                <span class="help fa hubtiger-tooltip tooltip-info" pTooltip="{{
        'onboarding.messages.technicians_info' | translate
      }}"></span>
            </div>
            <div class="wizard-message fail center margin-top-16" *ngIf="errorText !== ''">
                <div [innerHTML]="errorText"></div>
            </div>
            <div *ngFor="let technicians of techniciansName;let i = index;trackBy: indexTracker"
                 class="row margin-top-32">
                <div class="col-md-12">
                    <div class="input-group">
                        <input class="sign-up-input" type="text" name="userid-{{ i }}" [(ngModel)]="techniciansName[i]" placeholder="{{ 'onboarding.first_name' | translate}}"/>
<!--                        <label>{{ 'onboarding.first_name' | translate}}</label>-->
                    </div>
                </div>
            </div>
        </div>
        <div>
            <div class="row margin-top-32">
                <div class="col-md-12">
                    <button (click)="skipToHubtiger()" [disabled]="creatingDummyData"
                            class="iso-round-button iso-secondary-outline iso w-100 mb-2"
                            >{{ creatingDummyData ? ('onboarding.button.please_wait' | translate) : ('onboarding.button.skip_to_hubtiger' | translate)}}</button>
                </div>
                <div class="col-md-12">
                    <button  type="button" (click)="goNext()" class="iso-round-button iso-secondary w-100"
                            [disabled]="(workshopSelected && !hasTechnicians()) || creatingDummyData"
                    >{{ 'onboarding.button.next' | translate}}</button>
                </div>
            </div>
        </div>
        <div *ngIf="creatingDummyData" class="generate-data-message">
            <div>
                <p-progressSpinner [style]="{ width: '30px', height: '30px' }" strokeWidth="2" fill="transparent"
                                   animationDuration=".5s">
                </p-progressSpinner>
                <div>{{ 'onboarding.messages.prepare_data' | translate}}</div>
            </div>
        </div>
    </div>
</div>
